import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stripHtml',
  standalone: true
})
export class StripHtmlPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return '';
    }

    let newValue = value.replace(/<[^>]+>/g, ' ');
    newValue = newValue.replace('&nbsp;', '');
    newValue = newValue.replace('&amp;', '');

    return newValue.replace(/ +(?= )/g, '').trimStart();
  }
}
